import React from "react"
import SideBar from "../../../../common/layout/sidebar.component"
import GenericListing from "../../../../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../../../../state/listing/generic-listing"
import ContactTabs from "../../../components/contactTabsComponent"

const SupplierListing = () => { 
    
    SideBar.activateMenu("contacts")

    return (
        <>
            <ContactTabs />
            <GenericListing
                objectType={ObjectType.SUPPLIERS}
                selectableRows
            />
        </>
    )
}

export default SupplierListing



// WEBPACK FOOTER //
// ./src/customer/supplier/components/listing/SupplierListing.tsx